<template>
	<section class="page-dictionary">
		<header-page
			actions
			name="account-dictionary"
			:title="title"
			@run-action="runAction"
		/>
		<backButtonRoute/>
		<v-tabs
			align-with-title
			color="transparent"
			right
			slider-color="#33cfc7"
			class="px-4"
			v-model="activeTab">
			<v-tab
			v-for="(item, index) in tabs"
			:key="index"
			>
				{{ item.name }}
			</v-tab>
			<v-tabs-items v-model="activeTab">
				<v-card class="mt-3 mb-5">
					<dictionary-list
						:current-page="params.page"
						:last-page="table.lastPage"
						:rows="rows"
						@click-icon="clickIcon"
						@on-page="onPage"
						@on-search="onSearch"
					>
					</dictionary-list>
				</v-card>
			</v-tabs-items>
		</v-tabs>
		<section class="modal-filter-footer">
			<modal-sidebar-button
			hidden
			success-color="primary"
			success-text="Atras"
			@accept-button-clicked="returnDictionary"
			></modal-sidebar-button>
		</section>
		<action-bar
			class="action-mobile"
			:resource-uri="$route.name"
			@run-action="runAction"
		/>
		<action-sidebar
			:title="action.title"
			:value="action.visible"
			:width="action.width"
			@close-modal="closeModal"
		>
		<v-layout  wrap ma-2 v-if="flagImportExcel">
				<v-flex xs12 mt-3>
				<label ref="label" for="download-excel">
					<vue-six-four
						ref="vueSixFour"
						id="download-excel"
						hidden
						@vue-six-four="getFile"
					/>
					<v-layout>
						<v-flex xs12 mr-2 class="text-right" >
							<v-btn
								color="success"
								class="btnLoadExcel white--text"
								@click="downloadRules"
							>
								Descargar Plantilla
							<v-icon right dark>file_download</v-icon>
							</v-btn>
						</v-flex>
					</v-layout>
					<v-layout>
						<v-flex xs12 class="container-import">
							<BaseInput
								:height="35"
								label="Adjuntar excel"
								v-model="excelName"
								required
								class="pr-4"
							>
								<span slot="error" class="caption error--text" v-if="!$v.model.base64.required">
									Es necesario importar un archivo excel
								</span>
							</BaseInput>
							<button class="btn-import" @click="showDialog">
								<img src="/static/img/actions-list/excel.svg" alt="importar excel">
							</button>
						</v-flex>
					</v-layout>
				</label>
			</v-flex>
			<section class="modal-filter-footer">
			<modal-sidebar-button
				success-text="Aceptar"
				@cancel-button-clicked="closeModal"
				@accept-button-clicked="sendAccount"
				:is-loading="$v.$invalid || disabledbutton"
			>
			</modal-sidebar-button>
		</section>
					</v-layout>
			<dictionaryForm
				v-if="isDictionaryForm"
				:id="selectedRow.id"
				:data-type="dataType"
				:subsidiary-module-id="moduleId"
				@close-modal="closeModal"
			/>
			<dictionaryFormRemove
				v-if="isDictionaryRemove"
				:id="selectedRow.id"
				:name="selectedRow.name"
				@close-modal="closeModal"
			/>
		</action-sidebar>
	</section>
</template>

<script>

import {
	ACCOUNTING_DICTIONARY_NEW_ATS,
	ACCOUNTING_DICTIONARY_REMOVE,
	ACCOUNTING_DICTIONARY_FORM_ATS,
} from '@/shared/action-codes';
import actionBar from '@/components/shared/action-bar/action-bar';
import actionSidebar from '@/components/shared/action-sidebar';
import backButtonRoute from '@/components/shared/back-button-route';
import dictionaryList from '@/components/dictionary/dictionary-list';
import dictionaryForm from '@/components/dictionary-ats/dictionary-ats-form';
import dictionaryFormRemove from '@/components/dictionary-ats/dictionary-ats-form-remove';
import appButton from '@/components/shared/app-button';
import { required } from 'vuelidate/lib/validators';
import VueSixFour from 'vue-six-four';
import { mapGetters } from 'vuex';

function data() {
	return {
		action: {
			code: '',
			title: '',
			visible: false,
		},
		activeTab: 0,
		disabledbutton: false,
		flagImportExcel: false,
		rows: [],
		limit: 10,
		model: {
			base64: {
				required,
			},
		},
		excelName: null,
		selectedRow: {
			id: null,
		},
		tabs: [
			{ id: 1, name: 'Cabecera', disabled: false },
			{ id: 2, name: 'Detalle', disabled: false },
		],
	};
}
function validations() {
	const validation = {
		model: {
			base64: {
				required,
			},
		},
	};
	return validation;
}
function getFile(fileInfo) {
	this.excelName = fileInfo.name.replace(/\s/g, '-');
	const base64data = fileInfo.sixFour.split('base64,');
	this.model.base64 = base64data[1];
}
async function loadData() {
	this.$set(this.params, 'moduleId', this.moduleId);
	this.$set(this.params, 'dataType', this.dataType);
	this.$set(this.params, 'limit', this.limit);
	const { records } = await this.loadData('data-dictionary-transactional');
	this.rows = records.map(({ id, code, description, example, name, subsidiaryModuleId }) =>
		({ code, description, example, name, id, subsidiaryModuleId }),
	);
	return this.rows;
}

function clickIcon({ action, row }) {
	this.selectedRow.subsidiaryModuleId = row.subsidiaryModuleId;
	this.selectedRow.id = row.id;
	this.selectedRow.name = row.name;
	if (action === 'edit') {
		this.action.title = `Editar - ${row.name}`;
		this.action.code = ACCOUNTING_DICTIONARY_FORM_ATS;
	} else if (action === 'delete') {
		this.action.code = ACCOUNTING_DICTIONARY_REMOVE;
		this.action.title = `Eliminar - ${row.name}`;
	}
	this.action.visible = true;
}

function closeModal(reloadList) {
	this.action.code = '';
	this.action.title = '';
	this.action.visible = false;
	this.selectedRow.id = 0;
	this.flagImportExcel = false;
	if (reloadList) {
		loadData.call(this);
	}
}

async function created() {
	await loadData.call(this);
}

function customerId() {
	return Number(this.$route.query.customerId);
}

function dataType() {
	return this.activeTab + 1;
}

function isDictionaryForm() {
	return this.action.code === ACCOUNTING_DICTIONARY_FORM_ATS
		|| this.action.code === ACCOUNTING_DICTIONARY_NEW_ATS;
}

function isDictionaryRemove() {
	return this.action.code === ACCOUNTING_DICTIONARY_REMOVE;
}

function moduleId() {
	return Number(this.$route.query.id);
}

async function onPage(page) {
	this.params.page = page;
	await loadData.call(this);
}
async function downloadRules() {
	const body = {
		customerId: this.currentSubsidiary.customerId,
		subsidiaryId:	this.currentSubsidiary.id,
		companyId: this.currentSubsidiary.companyId,
	};
	const response = await this.$http.post('data-dictionary-transactional-download-excel', body);
	const byteCharacters = atob(response.data.base64);
	const byteNumbers = [];
	byteCharacters.split('').forEach((char) => {
		byteNumbers.push(char.charCodeAt(0));
	});

	const byteArray = new Uint8Array(byteNumbers);
	const buffer = byteArray.buffer;

	// Crear un Blob a partir del ArrayBuffer
	const blob = new Blob([buffer], { type: 'application/octet-stream' });

	// Crear un objeto URL para descargar el archivo
	const url = URL.createObjectURL(blob);

	// Crear un enlace (link) para la descarga
	const link = document.createElement('a');
	link.href = url;
	link.download = 'diccionario_contables_ats.xlsx'; // Cambia el nombre del archivo según desees

	// Simular un clic para iniciar la descarga
	link.click();

	// Revocar el objeto URL para liberar recursos del navegador
	URL.revokeObjectURL(url);
}
async function onSearch(value) {
	this.params.page = 1;
	this.$set(this.params, 'search', value || null);
	await loadData.call(this);
}

function runAction({ name, code }) {
	if (code === 'diccionary-automatic-by-excel') {
		this.action.title = 'Importar Diccionario Ats';
		this.action.width = 350;
		this.action.visible = true;
		this.flagImportExcel = true;
	} else {
		this.action.title = name;
		this.action.code = code;
		this.action.visible = true;
		this.selectedRow.id = 0;
	}
}

function subsidiaryId() {
	return Number(this.$route.query.subsidiaryId);
}

async function sendAccount() {
	const method = 'post';
	const url = 'data-dictionary-transactional-upload';
	const action = 'creó';
	const newModel = { ...this.model };
	newModel.companyId = Number(this.currentSubsidiary.companyId);
	try {
		this.disabledbutton = true;
		await this.$http[method](url, newModel);
		this.disabledbutton = false;
		this.showNotification(`Se ${action} correctamente`);
		this.loadData();
		this.closeModal();
	} catch (error) {
		if (error.status === 500) {
			this.showGenericError();
		} else if (error.status === 400) {
			if (error.data.message === 'DATA_DICTIONARY_REPEAT') {
				this.showGenericError('No se puede registrar el dictionario algun dato repetido.');
			} else if (error.data.message === 'FILE_XLSX_ITEM_EMPTY') {
				this.showGenericError('Un item del archivo se encuentra vacío.');
			}
		}
	}
}

function title() {
	return `${this.$route.query.name} / ${this.$route.meta.title}`;
}

async function watchActiveTab() {
	this.params.page = 1;
	await loadData.call(this);
}

function returnDictionary() {
	this.$router.go(-1);
}
function showDialog() {
	this.$refs.label.click();
}

export default {
	name: 'accounting-dictionary-ats',
	created,
	components: {
		actionBar,
		actionSidebar,
		appButton,
		dictionaryForm,
		BaseInput: () => import('@/components/shared/inputs/base-input'),
		dictionaryList,
		VueSixFour,
		dictionaryFormRemove,
		backButtonRoute,
	},
	computed: {
		...mapGetters('subsidiary', [
			'currentSubsidiary',
		]),
		customerId,
		dataType,
		isDictionaryForm,
		isDictionaryRemove,
		moduleId,
		subsidiaryId,
		title,
	},
	data,
	methods: {
		clickIcon,
		sendAccount,
		showDialog,
		closeModal,
		getFile,
		downloadRules,
		onPage,
		onSearch,
		returnDictionary,
		runAction,
	},
	watch: {
		activeTab: watchActiveTab,
	},
	validations,
};
</script>
<style lang="scss" scoped>
.container-import {
		position: relative;

		.btn-import {
			background: #03A89E;
			border-radius: 0 5px 5px 0;
			height: 35px;
			padding: 5px 7px 5px 0;
			position: absolute;
			right: 0;
			top: 16px;
			width: 51px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/pages/atsDictionary/ats-list-dictionary.vue